import { connect } from 'react-redux';
import Articles from '../components/Articles';
import Immutable from 'immutable';
import { trUri } from '../utils';
// import * as Actions from '../actions';

function mapStateToProps(state) {
  // do not iterate on subsections
  const tokenizedUri = state.routing.locationBeforeTransitions.pathname.split('/');
  const sectionUri = `/${tokenizedUri[2]}`;
  const lang = tokenizedUri[1];

  const topSection = state.luraschi.getIn(['data', 'data'])
    .filter(item => trUri(item.get('meta'), lang) === sectionUri).first();

  const currentSection = (tokenizedUri.length === 3) ?
    topSection.get('data', new Immutable.List()).first() :
    topSection.rest().get('data')
    .filter(item =>
      trUri(item.get('meta', new Immutable.Map()), lang)
        === `/${tokenizedUri[2]}/${tokenizedUri[3]}`)
    .first();

  return {
    items: currentSection.get('data'),
    lang,
  };
}

// function mapDispatchToProps(dispatch) {
  // return bindActionCreators(Actions, dispatch);
// }

export default connect(mapStateToProps)(Articles);



// WEBPACK FOOTER //
// ./common/containers/Articles.js